<template>

  <div id="app">

    <!-- START NAVBAR -->

    <Navbar v-show="!['customerNotice'].includes($route.name) && !isMobile" />



    <div>

      <router-view />

    </div>



    <Footer v-show="!['customerNotice'].includes($route.name) && !isMobile" />

    <BackToTop v-show="!['customerNotice'].includes($route.name)" />

  </div>

</template>



<script>

import Navbar from "@/components/tabbar/navbar.vue";

import Footer from "@/components/tabbar/footer.vue";

import BackToTop from "@/components/BackToTop.vue";



export default {

  components: {

    Navbar,

    Footer,

    BackToTop,

  },

  data() {

    return {

      isMobile: false,

    };

  },

  created() {

    this.checkMobile();

    window.addEventListener('resize', this.checkMobile);

  },

  beforeDestroy() {

    window.removeEventListener('resize', this.checkMobile);

  },

  methods: {

    checkMobile() {

      this.isMobile = window.innerWidth <= 768;

    },

  },

};

</script>


